<header class="header-main" [class.menuopen]="isMobileMenuOpen">
    <div class="header__container">
        <div class="container-xxl">
            <div class="header__block__content">
                <nav class="header__navbar">
                    <div class="header__logo ps-lmd-2">
                        <fe-button
                            [btnClass]="'p-0'"
                            [style]="'link'"
                            [href]="'' | formatUrl"
                        >
                            <img
                                class="logo__header"
                                alt="logo-header"
                                [src]="'images/logo-alamo.webp' | cdn"
                            />
                        </fe-button>
                    </div>
                    <ul
                        class="header_menu bounded-container d-none d-slmd-flex"
                    >
                        <li class="header__menu__opContainer">
                            <div
                                class="d-flex header__menu__trigger"
                                (click)="
                                    toggleSubmenu('submenuReservation', $event)
                                "
                            >
                                <fe-button
                                    [btnClass]="'fw-bold p-0'"
                                    [style]="'link-fifth'"
                                    ><span>{{
                                        'fe_menu_reservacion_link' | translate
                                    }}</span></fe-button
                                >
                                <i
                                    class="bi bi-caret-down-fill"
                                    [class.open]="
                                        openSubmenuId === 'submenuReservation'
                                    "
                                ></i>
                            </div>
                            <ul class="header__submenu" id="submenuReservation">
                                <li class="header__submenu__opContainer">
                                    <fe-button
                                        [btnClass]="
                                            'header__link__submenu text-start fw-bold p-0'
                                        "
                                        [style]="'link-fifth'"
                                        [href]="'/' | formatUrl"
                                        [fragment]="'doReservation'"
                                        ><span>{{
                                            'fe_menu_do_reservacion_link'
                                                | translate
                                        }}</span></fe-button
                                    >
                                </li>
                                <li
                                    *ngIf="
                                        configuration.featuresFlags.value
                                            ?.viewCancelReservation === true
                                    "
                                    class="header__submenu__opContainer"
                                >
                                    <fe-button
                                        [btnClass]="
                                            'header__link__submenu text-start fw-bold p-0'
                                        "
                                        [style]="'link-fifth'"
                                        [href]="
                                            'check-your-reservation' | formatUrl
                                        "
                                        ><span>{{
                                            'fe_menu_go_reservacion_link'
                                                | translate
                                        }}</span></fe-button
                                    >
                                </li>
                            </ul>
                        </li>
                        <li class="header__menu__opContainer d-flex">
                            <fe-button
                                [btnClass]="'fw-bold p-0'"
                                [style]="'link-fifth'"
                                [href]="'promos-and-agreements' | formatUrl"
                                ><span>{{
                                    'fe_menu_promociones_link' | translate
                                }}</span></fe-button
                            >
                        </li>
                        <li class="header__menu__opContainer d-flex">
                            <fe-button
                                [btnClass]="'fw-bold p-0 ms'"
                                [style]="'link-fifth'"
                                [href]="'/blog'"
                                [target]="'_blank'"
                                ><span>{{
                                    'fe_core_footer_link_blog' | translate
                                }}</span></fe-button
                            >
                        </li>
                        <li class="header__menu__opContainer d-flex">
                            <fe-button
                                [btnClass]="'fw-bold p-0'"
                                [style]="'link-fifth'"
                                [href]="'corporate' | formatUrl"
                                ><span>{{
                                    'fe_menu_empresas_link' | translate
                                }}</span></fe-button
                            >
                        </li>
                        <li
                            *ngIf="
                                configuration.featuresFlags.value
                                    ?.precheckin === true
                            "
                            class="header__menu__opContainer d-flex mx-0"
                        >
                            <fe-button
                                [btnClass]="'fw-bold p-0 mx-0'"
                                [style]="'link-fifth'"
                                [href]="'pre-check-in' | formatUrl"
                                ><span>{{
                                    'fe_menu_precheckin_link' | translate
                                }}</span></fe-button
                            >
                        </li>
                        <li class="header__menu__opContainer">
                            <fe-button
                                [btnClass]="'fw-bold p-0'"
                                [style]="'link-fifth'"
                                [href]="'locations-and-offices' | formatUrl"
                                ><span>{{
                                    'fe_menu_destination_link' | translate
                                }}</span></fe-button
                            >
                        </li>
                    </ul>
                </nav>
                <div class="header__contact">
                    <a
                        class="btn-link1 phone d-none d-sm-block phone_hover"
                        href="tel:{{ 'fe_header_menu_link_phone' | translate }}"
                    >
                        <img
                            class="whatsapp-phone-icon"
                            alt="whatsapp"
                            [src]="'images/icon-whatsapp.svg' | cdn"
                        />
                        {{ 'fe_header_menu_link_phone' | translate }}
                    </a>

                    <a
                        class="btn-link1 phone d-block d-sm-none"
                        href="tel:{{ 'fe_header_menu_link_phone' | translate }}"
                    >
                        <img
                            class="contac-phone"
                            alt="phone-contact"
                            [src]="'images/phone-icon-blue.svg' | cdn"
                        />
                    </a>
                    <div
                        class="header__menu__opContainer d-none d-slmd-block pe-2 pe-lmd-4"
                    >
                        <i class="bi bi-globe"></i>
                        <button
                            [ngClass]="
                                currentLanguage === 'en' ? 'selected' : ''
                            "
                            class="header__top__link switch-language"
                            (click)="toggleSubmenu('submenuLang', $event)"
                        >
                            {{ currentLangtxt }}
                        </button>
                        <img
                            class="arrow-down-menu"
                            alt="arrow menu"
                            [src]="'images/arrow_select.svg' | cdn"
                        />
                        <ul class="header__submenu" id="submenuLang">
                            <li class="header__submenu__opContainer">
                                <a
                                    class="header__link__submenu language"
                                    [attr.href]="
                                        [
                                            env.baseUrl,
                                            currentLanguage === 'en'
                                                ? 'es'
                                                : 'en'
                                        ].join('/')
                                    "
                                >
                                    {{ idiomaChange }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <button
                        class="header__menumb__container"
                        (click)="toggleMobileMenu()"
                        [class.menuactive]="isMobileMenuOpen"
                    >
                        <i class="header__menumb_bar">
                            <svg
                                class="barsvg"
                                viewBox="0 0 100 80"
                                width="40"
                                height="40"
                                *ngIf="!isMobileMenuOpen"
                            >
                                <rect width="100" height="10"></rect>
                                <rect y="27" width="100" height="10"></rect>
                                <rect y="53" width="100" height="10"></rect>
                            </svg>
                        </i>
                        <span
                            class="header__menumb_txt"
                            *ngIf="!isMobileMenuOpen"
                            >MENU</span
                        >
                        <img
                            class="close-menu-img"
                            alt="close menu"
                            [src]="'/images/close.svg' | cdn"
                            *ngIf="isMobileMenuOpen"
                        />
                    </button>
                    <fe-menu-mobile
                        [isOpen]="isMobileMenuOpen"
                        [currentLangtxt]="currentLangtxt"
                        [idiomaChange]="idiomaChange"
                        [currentLanguage]="currentLanguage"
                        [changeLangCode]="changeLangCode"
                        class="d-block d-lmd-none"
                    >
                    </fe-menu-mobile>
                </div>
            </div>
        </div>
    </div>
</header>
